export default {
  AUTHENTICATION_ERROR: 401
};
